import React__default from 'react';
import './navbar.css.js';
import { Navigate } from '@pkvsinha/react-navigate';

function MenuLink({ href, label, icon, className = "", style, }) {
    return (React__default.createElement("li", { className: `menu-link ${className}`, style: style },
        React__default.createElement(Navigate, { to: href, className: "menu-item" },
            React__default.createElement("span", { className: "menu-icon" }, icon),
            React__default.createElement("span", { className: "menu-label" }, label))));
}
function NavBar({ position = "bottom", links, logo, logoAlt = "Logo", className = "", style, }) {
    return (React__default.createElement("div", { className: `navbar-container navbar-${position} ${className}`, style: style },
        React__default.createElement("nav", { className: "navbar" },
            logo && (React__default.createElement("div", { className: "navbar-logo" },
                React__default.createElement("a", { href: "/" },
                    React__default.createElement("img", { src: logo, alt: logoAlt })))),
            React__default.createElement("ul", { className: "menu" }, links === null || links === void 0 ? void 0 : links.map((link, i) => (React__default.createElement(MenuLink, Object.assign({ key: i }, link))))))));
}

export { NavBar };
//# sourceMappingURL=NavBar.js.map
